import type { StreamingState } from "../stores/StreamingStore";

/**
 * Single handler for the sources-related keys of an SSE `metadata` event.
 * New sources-related keys belong here, not in the per-surface handlers.
 */
export const applySourcesMetadata = (
  metadata: any,
  {
    setResponseSources,
    setSearchedEntries,
  }: Pick<StreamingState, "setResponseSources" | "setSearchedEntries">,
): void => {
  if (metadata?.assistant_response_sources) {
    setResponseSources(metadata.assistant_response_sources);
  }

  // Live Searched-tier entries, streamed at tool completion (#20423) so the
  // Sources panel's Searched tier populates mid-turn.
  if (metadata?.searched_entries) {
    setSearchedEntries(metadata.searched_entries);
  }
};
